import { render, staticRenderFns } from "./Notifications.vue?vue&type=template&id=ecd59540&"
import script from "./Notifications.vue?vue&type=script&lang=js&"
export * from "./Notifications.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/skysql-ui-client/skysql-ui-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ecd59540')) {
      api.createRecord('ecd59540', component.options)
    } else {
      api.reload('ecd59540', component.options)
    }
    module.hot.accept("./Notifications.vue?vue&type=template&id=ecd59540&", function () {
      api.rerender('ecd59540', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/settings/Notifications.vue"
export default component.exports